import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { CONFIRM_DELETE_ART_FOLDER_LOGO_POPUP, COMPANY_ART_FOLDER_ALL_LOGOS_POPUP } from 'swag-client-common/constants';
import { isCompanyArtFolderAllLogosPopupShownSelector } from 'swag-client-common/redux/popup-manager/popup-manager.selector';
import { hidePopup, showPopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { resetLogosPaginationAction } from 'swag-client-common/redux/company-art-folder/company-art-folder.actions';
import { uploadLogo } from '../../../redux/product/product.actions';
import { fullLogosListSelector, isLogosListLoadingSelector, isLogosListEmptySelector, isInitialLoadingSelector, isPartLoadingSelector, showLogosListSelector, selectedLogoViewSelector, hasMoreLogosSelector } from '../../../redux/company-art-folder/company-art-folder.selectors';
import { selectArtFolderLogo, getCompanyArtFolderList } from '../../../redux/company-art-folder/company-art-folder.actions';
import hasPostscriptExtension from '../../../utils/has-postscript-extension';
import { CompanyArtFolderAllLogosPopup as CompanyArtFolderAllLogosPopupComponent } from './company-art-folder-all-logos-popup';
const DEFAULT_ART_FOLDER_PER_PAGE = 12;
const mapStateToProps = createStructuredSelector({
  open: isCompanyArtFolderAllLogosPopupShownSelector,
  isLoading: isLogosListLoadingSelector,
  isInitialLoading: isInitialLoadingSelector,
  isPartLoading: isPartLoadingSelector,
  isListEmpty: isLogosListEmptySelector,
  showList: showLogosListSelector,
  logos: fullLogosListSelector,
  hasMoreLogos: hasMoreLogosSelector,
  view: selectedLogoViewSelector
});
const mapDispatchToProps = dispatch => ({
  onClose: () => {
    dispatch(hidePopup());
  },
  onSubmitSelectedLogo: logo => {
    dispatch(selectArtFolderLogo(logo));
  },
  onUploadLogo: (file, view) => {
    dispatch(uploadLogo(file, view));
    if (hasPostscriptExtension(file)) {
      dispatch(hidePopup());
    }
  },
  updateLogoPagination: () => {
    dispatch(resetLogosPaginationAction(DEFAULT_ART_FOLDER_PER_PAGE));
  },
  loadMoreLogos: () => {
    dispatch(getCompanyArtFolderList());
  },
  onDeleteLogo: logo => {
    dispatch(showPopup({
      popup: CONFIRM_DELETE_ART_FOLDER_LOGO_POPUP,
      logo,
      popupToShowAfter: COMPANY_ART_FOLDER_ALL_LOGOS_POPUP
    }));
  }
});
export const CompanyArtFolderAllLogosPopup = connect(mapStateToProps, mapDispatchToProps)(CompanyArtFolderAllLogosPopupComponent);